/**
 * Single-segment paths used by the main app — ad slugs cannot use these.
 * Keep in sync with backend/utils/adShortLinkReservedSlugs.js
 */
const RESERVED = new Set([
  'login',
  'register',
  'forgot-password',
  'reset-password',
  'verify-email',
  'auth',
  'getting-started',
  'about',
  'faq',
  'mobile-app',
  'terms',
  'privacy',
  'privacy-policy',
  'contact',
  'delete-account',
  'data-deletion',
  'child-safety',
  'csae-standards',
  'shadchan',
  'single',
  'parent',
  'messages',
  'my-resumes',
  'subscription',
  'static',
  'api'
]);

const SLUG_RE = /^[a-z0-9-]{1,64}$/;

/**
 * @param {string} path normalized path (no trailing slash), e.g. "/mm"
 * @returns {string|null} slug for ad redirect route, or null
 */
export function getAdShortLinkSlugFromPath(path) {
  const p = (path || '/').replace(/\/+$/, '') || '/';
  if (p === '/') return null;
  const parts = p.split('/').filter(Boolean);
  if (parts.length !== 1) return null;
  const slug = parts[0].toLowerCase();
  if (!SLUG_RE.test(slug) || RESERVED.has(slug)) return null;
  return slug;
}
